import { render, staticRenderFns } from "./FinesTab.vue?vue&type=template&id=18ff1e3d&scoped=true&"
import script from "./FinesTab.vue?vue&type=script&lang=js&"
export * from "./FinesTab.vue?vue&type=script&lang=js&"
import style0 from "./FinesTab.vue?vue&type=style&index=0&id=18ff1e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff1e3d",
  null
  
)

export default component.exports